import { render } from "./ConsultDetail_DataGovernance.vue?vue&type=template&id=4340202d&scoped=true"
import script from "./ConsultDetail_DataGovernance.vue?vue&type=script&lang=js"
export * from "./ConsultDetail_DataGovernance.vue?vue&type=script&lang=js"

import "./ConsultDetail_DataGovernance.vue?vue&type=style&index=0&id=4340202d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4340202d"]])

export default __exports__